/** @jsxImportSource @emotion/react */
import React from "react";
import { BLOCK_EXPLORER_URL_BY_NETWORK } from "../../../../config/consts";
import { ReactComponent as ApprovedTick } from "../../../../img/butter_svgs/ApprovedTick.svg";
import { ReactComponent as ViewBlock } from "../../../../img/butter_svgs/ViewBlock.svg";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Text } from "../../../general/Text";
import { css } from "@emotion/react";
import { approvalSpinnerWrapper } from "../../../../config/commonCSS";
import styled from "@emotion/styled";
import { FlexContainer } from "../../../../containers/FlexContainer";

export const Approved: React.FC<{ tx: string; isVisible: boolean }> = ({ isVisible, tx }) => {
  const network = GlobalStore.useState(s => s.network);
  const theme = GlobalStore.useState(s => s.theme);
  if (!isVisible) {
    return null;
  }
  return (
    <ApprovedContainer>
      <ViewBlock style={{ color: `${theme.font.primary.default} !important` }} />
      <a
        href={`${BLOCK_EXPLORER_URL_BY_NETWORK[network.id]}tx/${tx}`}
        target="_blank"
        rel="noreferrer"
        css={css`
          margin-left: 2px;
          margin-right: 12px;
        `}
        style={{ textDecoration: "none" }}
      >
        <Text textStyle={"Paragraph"} size={"Large"} color={theme.font.primary.default}>
          Details
        </Text>
      </a>
      <div css={approvalSpinnerWrapper}>
        <ApprovedTick />
      </div>
    </ApprovedContainer>
  );
};

const ApprovedContainer = styled(FlexContainer)`
  font-size: 14px;
  font-weight: 400;
  justify-content: end;
`;
